import { useState } from 'react';
import { Save, Eye, EyeOff } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/admin`;

const SettingsManager = ({ getAuthHeader }) => {
  const [credentials, setCredentials] = useState({
    current_password: '',
    new_username: '',
    new_password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const updateCredentials = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${API}/update-credentials`, credentials, getAuthHeader());
      alert('✅ Identifiants mis à jour ! Veuillez vous reconnecter.');
      setCredentials({ current_password: '', new_username: '', new_password: '' });
    } catch (error) {
      alert('❌ ' + (error.response?.data?.detail || 'Erreur'));
    }
  };

  return (
    <div className="admin-tab-content">
      <h1>Paramètres du Compte</h1>
      <div className="admin-section">
        <h2>Modifier les Identifiants</h2>
        <form onSubmit={updateCredentials} className="admin-form">
        <div className="admin-form-group">
          <label>Mot de passe actuel *</label>
          <div className="password-input-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              value={credentials.current_password}
              onChange={(e) => setCredentials({...credentials, current_password: e.target.value})}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="password-toggle"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
        </div>
        <div className="admin-form-group">
          <label>Nouveau nom d&apos;utilisateur (optionnel)</label>
          <input
            type="text"
            value={credentials.new_username}
            onChange={(e) => setCredentials({...credentials, new_username: e.target.value})}
          />
        </div>
        <div className="admin-form-group">
          <label>Nouveau mot de passe (optionnel)</label>
          <input
            type="password"
            value={credentials.new_password}
            onChange={(e) => setCredentials({...credentials, new_password: e.target.value})}
          />
        </div>
        <button type="submit" className="admin-button-primary">
          <Save size={18} /> Enregistrer les Modifications
        </button>
        </form>
      </div>
    </div>
  );
};

export default SettingsManager;
